"use client"

import { useTranslations } from "next-intl"

import { IconButton } from "@/components/ui/icon-button"
import { BackChevronIcon } from "@/components/ui/icons/back"
import { CHECKOUT_HOLD_CANCEL_ATTRIBUTE, dismissCheckoutHold } from "@/lib/checkout/pdp-checkout-link"
import { useShallowQueryParams } from "@/lib/hooks/use-navigation"

export const PdpCheckoutHoldCancel = () => {
  const t = useTranslations("common")
  const updateQuery = useShallowQueryParams()
  const cancel = () => {
    dismissCheckoutHold()
    updateQuery({ signup: null, preview: null }, { replace: true })
  }
  return (
    <IconButton aria-label={t("goBack")} {...{ [CHECKOUT_HOLD_CANCEL_ATTRIBUTE]: "" }} className="border-surface-warm-deep size-10" icon={<BackChevronIcon />} onClick={cancel} />
  )
}
